// @flow
import { useQuery, type QueryResult } from 'react-query';
import { provider as providerApi } from './api';
import { Provider } from 'common/models/internal/Provider';

export default function useGetProvider(
    providerId: ?string
): QueryResult<?Provider> {
    return useQuery({
        queryKey: ['provider', providerId],
        queryFn: async () => {
            const provider = await providerApi.fetch({ providerId });
            return Provider.fromJS(provider);
        },
        enabled: !!providerId,
        refetchOnWindowFocus: false
    });
}
